module.exports = __webpack_public_path__ + "assets/ligapontos-esq.ed95438d.svg";